import Immutable from 'immutable'

export const SupplierRecord = Immutable.Record({
  contractId: null,
  unidPort: null,
  ntdId: null,
  supplier: null,
  phoneNumbers: Immutable.Set(),
}, 'ServiceSupplier')

export default function createServiceSupplier({
  contract_id,
  unid_port,
  ntd_id,
  phone_numbers,
  // eslint-disable-next-line no-unused-vars
  supplier_id,
  ...data
}) {
  return new SupplierRecord({
    contractId: contract_id,
    unidPort: unid_port,
    ntdId: ntd_id,
    phoneNumbers: Immutable.Set(phone_numbers),
    ...data,
  })
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Service/Supplier.js